import { render, staticRenderFns } from "./SpotlightCardCornerTag.vue?vue&type=template&id=505dbe14&scoped=true"
import script from "./SpotlightCardCornerTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotlightCardCornerTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpotlightCardCornerTag.vue?vue&type=style&index=0&id=505dbe14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505dbe14",
  null
  
)

export default component.exports